export default __webpack_public_path__ + "static/media/Thumbnail_Symbol.a19f31d1.svg";